// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-card{max-width:400px}.locations-grid .location-card{transition:all 100ms ease-out;height:100%}.locations-grid .location-card:hover,.locations-grid .location-card:focus{cursor:pointer;filter:brightness(1.1)}.locations-grid .location-card:active{filter:brightness(0.9)}\n", ""]);
// Exports
module.exports = exports;
